import { type SwitchFieldProps, get } from '@mfw/components';
import { SwitchField } from '@mfw/components';
import { type FieldError, Controller } from 'react-hook-form';

export type FormSwitchFieldProps = Omit<SwitchFieldProps, 'errors'>;

export const FormSwitchField = ({
  defaultValue,
  disabled,
  name,
  onChange,
  ...otherProps
}: FormSwitchFieldProps) => {
  return (
    <Controller
      render={({ field, formState: { errors, isLoading } }) => {
        const error = get<FieldError>(errors, name) ?? undefined;
        const fieldApi = field as any;
        return (
          <SwitchField
            errors={error?.message}
            {...field}
            {...otherProps}
            onChange={(e) => {
              const payload = {
                checked: e.target.checked,
                value: e.target.value,
              };
              field.onChange(payload);
              onChange?.(e, payload);
            }}
            loading={otherProps?.loading || isLoading}
            checked={fieldApi.checked}
            value={otherProps.value}
            disabled={disabled}
          />
        );
      }}
      name={name}
    />
  );
};
